export const ROUTES = { HOME: '/', ADD: '/add' };
